
import { useUserInfoStore } from "~/stores/userInfoStore"
export default () => {
    const userInfoStore = useUserInfoStore()

    return !!userInfoStore.info.is_trial
}